// This component is an svg only, with no functionality, so there's no need to
// have test coverage at this point.
/* istanbul ignore file */

import React from "react";
type AppointeddLogoProps = {
  className?: string;
};
export function AppointeddLogo({
  className
}: AppointeddLogoProps) {
  return <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 432 432" fill="none" role="img" aria-hidden data-sentry-element="svg" data-sentry-component="AppointeddLogo" data-sentry-source-file="AppointeddLogo.tsx">
      <defs data-sentry-element="defs" data-sentry-source-file="AppointeddLogo.tsx">
        <style>{`
        .cls-1 {
          fill: #90d5ef;
        }

        .cls-2 {
          fill: #de028e;
        }

        .cls-3 {
          fill: #fff;
        }

        .cls-4 {
          fill: #cc40b9;
        }
      `}</style>
      </defs>
      <circle className="cls-2" cx="144" cy="144" r="144" data-sentry-element="circle" data-sentry-source-file="AppointeddLogo.tsx" />
      <circle className="cls-1" cx="288" cy="288" r="144" data-sentry-element="circle" data-sentry-source-file="AppointeddLogo.tsx" />
      <path className="cls-3" d="M127.53,154.11c8.53-15.93,20.26-28.29,35.19-37.07,14.93-8.78,31.55-13.17,49.87-13.17s33.74,3.89,47.05,11.67c13.3,7.78,21.83,16.67,28.36,28.47v-36h36v207h-36v-36c-6.78,12.04-15.51,18.14-28.93,26.04-13.43,7.9-29.05,11.86-46.86,11.86s-34.88-4.52-49.68-13.55c-14.81-9.03-26.48-21.7-35-38.01-8.53-16.31-12.8-34.87-12.8-55.7s4.26-39.58,12.8-55.52ZM278.59,170.76c-6.27-11.54-14.74-20.38-25.41-26.53-10.67-6.15-22.39-9.22-35.19-9.22s-24.47,3.01-35,9.03c-10.54,6.02-18.95,14.81-25.22,26.35-6.27,11.54-9.41,25.09-9.41,40.65s3.13,29.55,9.41,41.21c6.27,11.67,14.68,20.58,25.22,26.72,10.54,6.15,22.21,9.22,35,9.22s24.52-3.07,35.19-9.22c10.66-6.15,19.13-15.06,25.41-26.72,6.27-11.67,9.41-25.28,9.41-40.84s-3.14-29.1-9.41-40.65Z" data-sentry-element="path" data-sentry-source-file="AppointeddLogo.tsx" />
      <path className="cls-4" d="M278.59,170.57c-6.27-11.54-14.74-20.38-25.41-26.53-10.67-6.15-22.39-9.22-35.19-9.22s-24.47,3.01-35,9.03c-10.54,6.02-18.95,14.81-25.22,26.35-6.27,11.54-9.41,25.09-9.41,40.65s3.13,29.55,9.41,41.21c6.27,11.67,14.68,20.58,25.22,26.72,10.54,6.15,22.21,9.22,35,9.22s24.52-3.07,35.19-9.22c10.66-6.15,19.13-15.06,25.41-26.72,6.27-11.67,9.41-25.28,9.41-40.84s-3.14-29.1-9.41-40.65Z" data-sentry-element="path" data-sentry-source-file="AppointeddLogo.tsx" />
    </svg>;
}
export default AppointeddLogo;